export enum StatusUpload {
    INPUT = 1,
    LOADING = 2,
    FINISH = 3
}